<template>
<artmisads-modal
  ref="artmisadsModal"
  :visible.sync="showEditsModal"
  title="Edit"
  
  @cancel="hideEditsModal"
>
  <div>
     <a-form
        ref="formRef"
        :model="formState"
        name="basic"
         autocomplete="off"
       
      >
        <a-form-item name="fixFees" label="Fixed ArtemisAds Fees" :rules="[{ required: true, message: 'Placement Fees is required' }]">
          <a-select style="width: 100%;" @change="onChangeFixFees" v-model:value="formState.fixFees" :options='placementFeesOptions' />
        </a-form-item>
        <a-form-item v-if="formState.fixFees !== 'multiply'" name="fixedFeesRate" label="Fixed ArtemisAds Fees Rate" :rules="[{ required: true, message: 'Fixed ArtemisAds Fees Rate is required' }]">
          <a-input-number :min="0" :max="100" :disabled="formState.fixFees === 'multiply'" style="width: 100%;" v-model:value="formState.fixedFeesRate" />
        </a-form-item>
        <a-form-item v-if="formState.fixFees === 'multiply'" name="publicCommissionRate" label="Public Commission Rate" :rules="[{ required: true, message: 'Public Commission Rate is required' }]">
          <a-input-number :min="0" :max="100" :disabled="formState.fixFees !== 'multiply'" style="width: 100%;" v-model:value="formState.publicCommissionRate" />
        </a-form-item>
        <a-form-item name="placementFree" label="Placement Free" :rules="[{ required: true, message: 'Placement Free is required' }]">
          <a-input-number :min="0" :max="100" style="width: 100%;" v-model:value="formState.placementFree" />
        </a-form-item>
        <a-form-item name="platformMaxFeeRate" label="CPC Platform Fees " :rules="[{ required: true, message: 'CPC Platform Fees is required' }]">
          <a-input-number :min="0" :max="100" style="width: 100%;" v-model:value="formState.platformMaxFeeRate" />
        </a-form-item>
        <a-form-item name="accBonusPlatformMaxFeeRate" label="ACC Bonus Platform Fees " :rules="[{ required: true, message: 'ACC Bonus Platform Fees is required' }]">
          <a-input-number :min="0" :max="100" style="width: 100%;" v-model:value="formState.accBonusPlatformMaxFeeRate" />
        </a-form-item>
      </a-form>
  </div>
      <template #footer>
      <div class="footer">
        <artmisads-button isSquare="true" @click="showEditsModal = false">Cancel</artmisads-button>
        <artmisads-button isSquare="true" type="primary" @click="onSubmit">Submit</artmisads-button>
      </div>
    </template>
</artmisads-modal>
</template>
<script setup>
import { ref, defineExpose } from 'vue';
import { operatorSellerApi } from '~/server/index';
import { Empty, message } from "ant-design-vue";
const showEditsModal = ref(false);
const lableTitle = ref('');
const lableValue = ref('');
const formRef = ref(null);
const emits = defineEmits(['refresh']);
const formState = ref({
fixFees:'',
fixedFeesRate:'',
publicCommissionRate:'',
placementFree:'',
platformMaxFeeRate:20,
accBonusPlatformMaxFeeRate:20,
empty:""
});
const platformFeesInfo=ref({})
const placementFeesOptions=[
  {
    label:'Active',
    value:'fix',
  },
  {
    label:'Inactive',
    value:'multiply',
  }
]
const show=(platformFees)=>{
  formState.value={
    fixFees:platformFees.attributionCommissionConfigDetailVO.platformType,
    fixedFeesRate:platformFees.attributionCommissionConfigDetailVO.platformType === 'fix' ? platformFees.attributionCommissionConfigDetailVO.platformFeeFactor : platformFees.attributionCommissionConfigDetailVO.defaultCommissionRate,
    publicCommissionRate:platformFees.attributionCommissionConfigDetailVO.platformType === 'fix' ? platformFees.attributionCommissionConfigDetailVO.platformMaxFeeRate : platformFees.attributionCommissionConfigDetailVO.platformFeeFactor,
    placementFree:platformFees.placementCommissionConfigDetailVO.platformFeeFactor,
    platformMaxFeeRate:platformFees.cpcCommissionConfigDetailVO.platformMaxFeeRate,
    accBonusPlatformMaxFeeRate:platformFees.accBonusCommissionConfigDetailVO.platformMaxFeeRate,
    empty:""
  }
  platformFeesInfo.value=platformFees
 
  showEditsModal.value=true
}
const onChangeFixFees=(e)=>{
  if(e === 'fix'){
    formState.value.publicCommissionRate=platformFeesInfo.value.attributionCommissionConfigDetailVO.platformMaxFeeRate
  }else{
    formState.value.fixedFeesRate=platformFeesInfo.value.attributionCommissionConfigDetailVO.defaultCommissionRate
  }
}
const onSubmit=async()=>{
   await formRef.value.validate().then(res=>{

    const params={
      sellerId:platformFeesInfo.value.id,
      placement:{
        platformType:'fix',
        platformFeeFactor:formState.value.placementFree
      },
      attribution:{
        platformType: formState.value.fixFees,
        platformFeeFactor:formState.value.fixFees === 'fix' ? formState.value.fixedFeesRate : formState.value.publicCommissionRate ,
      },
      cpc:{
        platformMaxFeeRate:formState.value.platformMaxFeeRate,
      },
      accBonus:{
        platformMaxFeeRate:formState.value.accBonusPlatformMaxFeeRate,
      }
    }

    operatorSellerApi.setCommissionConfig(params).then(res => {
     
      if(res.success){
        message.success('Set Success')
      
      showEditsModal.value = false;
      emits('refresh')
      }else{
        message.error('Set Failed')
      }
    }).catch(err => {
      message.error('Set Failed')
    });
   })
}
const hideEditsModal=()=>{
  showEditsModal.value = false;
}
defineExpose({
  show
})
</script>
